// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:26-08-2025
import AccountType from './account.types';

/** ***************** GET ACCOUNT LIST START *********************** */
export const getAccountListStart = (getData: any) => ({
	type: AccountType.GET_ACCOUNT_LIST_START,
	payload: getData,
});

export const getAccountListSuccess = (successData: any) => ({
	type: AccountType.GET_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getAccountListFailure = (failureData: any) => ({
	type: AccountType.GET_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getAccountListResponseResetStart = () => ({
	type: AccountType.GET_ACCOUNT_LIST_RESPONSE_RESET,
});

export const getAccountListResponseChanged = () => ({
	type: AccountType.GET_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET ACCOUNT LIST END *********************** */

/** ***************** ADD ACCOUNT DETAILS START *********************** */
export const addAccountDetailsStart = (addData: any) => ({
	type: AccountType.ADD_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const addAccountDetailsSuccess = (successData: any) => ({
	type: AccountType.ADD_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const addAccountDetailsFailure = (failureData: any) => ({
	type: AccountType.ADD_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const addAccountDetailsResponseResetStart = () => ({
	type: AccountType.ADD_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const addAccountDetailsResponseChanged = () => ({
	type: AccountType.ADD_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE ACCOUNT DETAILS START *********************** */
export const updateAccountDetailsStart = (updateData: any) => ({
	type: AccountType.UPDATE_ACCOUNT_DETAILS_START,
	payload: updateData,
});

export const updateAccountDetailsSuccess = (successData: any) => ({
	type: AccountType.UPDATE_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const updateAccountDetailsFailure = (failureData: any) => ({
	type: AccountType.UPDATE_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const updateAccountDetailsResponseResetStart = () => ({
	type: AccountType.UPDATE_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const updateAccountDetailsResponseChanged = () => ({
	type: AccountType.UPDATE_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE ACCOUNT DETAILS END *********************** */

/** ***************** DELETE ACCOUNT DETAILS START *********************** */
export const deleteAccountDetailsStart = (deleteData: any) => ({
	type: AccountType.DELETE_ACCOUNT_DETAILS_START,
	payload: deleteData,
});

export const deleteAccountDetailsSuccess = (successData: any) => ({
	type: AccountType.DELETE_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteAccountDetailsFailure = (failureData: any) => ({
	type: AccountType.DELETE_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteAccountDetailsResponseResetStart = () => ({
	type: AccountType.DELETE_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const deleteAccountDetailsResponseChanged = () => ({
	type: AccountType.DELETE_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE ACCOUNT DETAILS END *********************** */
